var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-customer-search-form'),(_vm.isSearched)?_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-form',{ref:"customer-form",attrs:{"value":_vm.customerValid,"lazy-validation":""}},[_c('v-request-customer-form')],1),_c('v-registered-classroom-table')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }